import { Collapse } from '@material-ui/core';
import ClassName from 'app/styles/ClassName';
import styledFuncs from 'app/styles/styledFuncs';
import styledMixins from 'app/styles/styledMixins';
import { BasicProps } from 'app/tools/general.types';
import { useObservableBinding } from 'app/tools/hooks/misc-hooks';
import { ReactNode } from 'react';
import { BehaviorSubject } from 'rxjs';
import styled from 'styled-components/macro';
import Button from '../button/Button';
import Icon from '../icon/Icon';
import IconLib from '../icon/icon-lib';
import { InputTitle } from '../misc';

const ExtraDetailsContainer = styled('div').attrs({
  className: ClassName.NO_HEIGHT_MARGIN,
})`
  display: flex;
  ${styledMixins.collapseFix}
  > * {
    align-self: center;
  }
`;

const CollapseStyledChildren = styled(Collapse)<{ $noTop: boolean }>`
  margin-top: ${p => styledFuncs.pad(p.$noTop ? 0 : 1)};
  ${styledMixins.collapseFix}
  .MuiCollapse-wrapperInner > *:not(.${ClassName.NO_AUTO_MARGIN}) {
    margin: ${styledFuncs.pad()} 0;
    &${InputTitle} {
      margin: 0;
    }
  }
`;

type Props = {
  title: ReactNode;
  expanded$?: BehaviorSubject<boolean>;
  noTopMargin?: boolean;
  noButton?: boolean;
  titleColor?: 'primary';
  icons?: {
    expand?: IconLib;
    collapse?: IconLib;
  };
} & BasicProps;

export default function CollapseSection({
  title,
  children,
  expanded$: expInput$,
  noTopMargin = false,
  noButton = false,
  titleColor,
  className,
  icons,
}: Props): JSX.Element {
  const [expanded, expanded$] = useObservableBinding(
    expInput$ || false
  );
  const expandIcon = icons?.expand || IconLib.CHEVRON_DOWN;
  const collapseIcon = icons?.collapse || IconLib.CHEVRON_UP;

  return (
    <>
      <ExtraDetailsContainer>
        {typeof title === 'string' ? (
          <InputTitle
            color={titleColor}
            style={{ fontWeight: 'normal' }}
            onClick={() => expanded$.next(!expanded$.value)}
          >
            {title}
          </InputTitle>
        ) : (
          title
        )}
        {!noButton && (
          <Button
            iconButton={{ size: 'small' }}
            className="ml-1"
            onClick={() => expanded$.next(!expanded$.value)}
          >
            <Icon
              color={titleColor}
              icon={expanded ? collapseIcon : expandIcon}
            />
          </Button>
        )}
      </ExtraDetailsContainer>
      <CollapseStyledChildren
        in={expanded}
        $noTop={noTopMargin}
        {...{ className }}
      >
        {children}
      </CollapseStyledChildren>
    </>
  );
}
